import { adminDisplayName } from "@/hooks/useAdminRoster";

type SupportProfile = {
  id: string;
  name: string | null;
  email: string | null;
};

/** Inbox-only labels from the approved v2.5 Support roster. Full profile names
 * remain authoritative everywhere outside this compact navigation surface. */
export function supportRosterLabel(
  profile: SupportProfile | null | undefined,
  t: (key: string, fallback?: string) => string
): string {
  const display = adminDisplayName(profile, t);
  const first = display.trim().split(/\s+/)[0] || display;
  const emailLocal = profile?.email?.trim().toLowerCase().split("@")[0] ?? "";
  return first.toLowerCase() === "vivien" || emailLocal === "vivien"
    ? "Vivi"
    : first;
}
